import {
	SEND_MESSAGE_STREAM_INIT,
	SEND_MESSAGE_STREAM_THINKING,
	SEND_MESSAGE_STREAM_CHUNK,
	SEND_MESSAGE_STREAM_COMPLETE,
	SEND_MESSAGE_STREAM_ERROR,
	SEND_MESSAGE_STREAM_RESET,
	SEND_MESSAGE_STREAM_SET_CONVERSATION_ID,
} from '../actions/sendMessageStreamAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
	streamingState: null, // 'thinking', 'streaming', 'complete', 'error'
	accumulatedText: '', // Store chunks of text as they come in
	thinkingText: '', // Store the thinking message
	conversationId: null, // Store the conversation ID received from the stream
};

const sendMessageStreamReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEND_MESSAGE_STREAM_INIT:
			return {
				...state,
				apiState: 'loading',
				streamingState: null,
				accumulatedText: '',
				thinkingText: '',
			};

		case SEND_MESSAGE_STREAM_THINKING:
			return {
				...state,
				apiState: 'loading',
				streamingState: 'thinking',
				thinkingText: action.thinkingText,
			};

		case SEND_MESSAGE_STREAM_CHUNK:
			return {
				...state,
				apiState: 'loading',
				streamingState: 'streaming',
				// Use the fullText from the server instead of appending manually
				accumulatedText:
					action.fullText || state.accumulatedText + action.text,
			};

		case SEND_MESSAGE_STREAM_COMPLETE:
			return {
				...state,
				apiState: 'success',
				streamingState: 'complete',
				data: action.response,
				message: 'success',
			};

		case SEND_MESSAGE_STREAM_ERROR:
			return {
				...state,
				apiState: 'error',
				streamingState: 'error',
				error: action.error,
				message: 'error',
			};

		case SEND_MESSAGE_STREAM_SET_CONVERSATION_ID:
			return {
				...state,
				conversationId: action.conversationId,
			};

		case SEND_MESSAGE_STREAM_RESET:
			return initialState;

		default:
			return state;
	}
};

export default sendMessageStreamReducer;
